"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponseSchema = exports.dataSchema = exports.BodySchema = exports.method = exports.path = void 0;
exports.parseBody = parseBody;
exports.parseResponse = parseResponse;
const zod_1 = require("zod");
const common_1 = require("../../../common");
const lingo2_models_1 = require("lingo2-models");
const common_2 = require("../../../common");
// Здесь указываем path относительно основного роута
// например `${config.http.webUrl}` `${config.http.panelUrl}` `${config.http.backUrl}`
/** Относительно `${config.http.*}` */
exports.path = 'user-services';
exports.method = common_1.HttpMethod.PATCH;
// #region Request
// Тело запроса. Optional
exports.BodySchema = zod_1.z.object({
  id: zod_1.z.string().uuid(),
  title: zod_1.z.string().trim().optional().nullable(),
  excerpt: zod_1.z.string().optional().nullable(),
  cover_id: zod_1.z.string().optional().nullable(),
  description: zod_1.z.string().trim().optional().nullable(),
  language_id: zod_1.z.number().optional().nullable(),
  subject_id: zod_1.z.number().optional().nullable(),
  price_tier: zod_1.z.number().optional().nullable(),
  keywords: zod_1.z.array(zod_1.z.string()).optional().nullable(),
  duration: zod_1.z.number().optional().nullable(),
  discount: zod_1.z.number().optional().nullable(),
  discount_rule: zod_1.z.nativeEnum(lingo2_models_1.MeetingDiscountRuleEnum).optional().nullable(),
  category_id: zod_1.z.number().optional().nullable(),
  media_url: zod_1.z.string().optional().nullable(),
  school_id: zod_1.z.string().uuid().optional().nullable(),
  teacher_ids: zod_1.z.array(zod_1.z.string().uuid()).optional().nullable(),
  type: zod_1.z.nativeEnum(lingo2_models_1.EUserServiceType).optional().nullable(),
  options: zod_1.z.object({
    requirements: zod_1.z.array(zod_1.z.string()).optional(),
    skills: zod_1.z.array(zod_1.z.string()).optional(),
    weekdays: zod_1.z.array(zod_1.z.nativeEnum(lingo2_models_1.WeekdaysEnum)).optional(),
    meetings_limit: zod_1.z.number().optional(),
    age_from: zod_1.z.number().optional(),
    age_to: zod_1.z.number().optional()
  }).optional().nullable(),
  level_id: zod_1.z.number().optional().nullable(),
  participants_limit: zod_1.z.number().optional().nullable(),
  moderation_status: zod_1.z.nativeEnum(lingo2_models_1.ModerationStatusEnum).optional().nullable(),
  moderation_message: zod_1.z.string().optional().nullable(),
  promotion_status: zod_1.z.nativeEnum(lingo2_models_1.PromotionStatusEnum).optional().nullable(),
  advertisement_status: zod_1.z.nativeEnum(lingo2_models_1.AdvertisementStatusEnum).optional().nullable()
});
function parseBody(values) {
  return exports.BodySchema.parse(values);
}
// Параметры запроса. Optional
// export const ParamsSchema = z.object({});
// export type Params = z.infer<typeof ParamsSchema>;
// export function parseParams(values: Params) {
//   return ParamsSchema.parse(values);
// }
// Query параметры запроса. Optional
// export const QuerySchema = z.object({});
// export type Query = z.infer<typeof QuerySchema>;
// export function parseQuery(values: Query) {
//   return QuerySchema.parse(values);
// }
// #endregion
// #region Response
exports.dataSchema = common_2.userServiceSchema;
exports.ResponseSchema = common_1.ApiResponse.infer(exports.dataSchema);
function parseResponse(values) {
  return exports.ResponseSchema.parse(values);
}
// #endregion
